import jsbridge from '../jsbridge'
import app from '@/AppData'

const TAG = 'util'

// 判断是否手机号
function isPhoneNumber (phoneNum) {
  // 放宽判断条件
  let reg = /^1[3456789]\d{9}$/
  return reg.test(phoneNum)
}

/**
 * 重试 limit 次
 * @param promiseFn
 * @param limit
 * @returns {Promise<unknown>}
 */
function retryPromise (promiseFn, limit) {
  const promiseFns = []
  const history = []
  for (let i = 1; i < limit; i++) {
    promiseFns.push(getFailPromise)
  }
  const failPromiseChain = promiseFns.reduce((prev, cur) => {
    return prev.then(cur)
  }, getFailPromise())

  return new Promise((resolve, reject) => {
    failPromiseChain.then((result) => {
      reject(history)
    }, (error) => {
      resolve(error)
    })
  })

  function getFailPromise () {
    return new Promise((resolve, reject) => {
      promiseFn()
        .then((result) => {
          reject(result)
        })
        .catch((error) => {
          history.push(error)
          resolve(true)
        })
    })
  }
}

function getUrlKey (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}

function isEmpty (obj) {
  if (typeof obj == 'undefined' || obj == null || obj == '') {
    return true
  } else {
    return false
  }
}

function getCallForwardNum () {
  let num = app.getData().userSetting.phoneNum
  var numList = app.getData().userSetting.servingNum.numList
  //
  // let mobileServerName = getMobileServer(num)
  //
  // var type = '-1'
  // if(mobileServerName == 'chinaMobile') {
  //   type = '0'
  // } else if (mobileServerName == 'chinaUnion') {
  //   type = '1'
  // } else if (mobileServerName == 'chinaTelcom') {
  //   type = '2'
  // }
  // console.log(TAG, 'getCallForwardNum', 'num ' + num, 'type ' + type)

  // if (numList != undefined && numList instanceof Array && numList.length > 0) {
  //   // 找到运营商
  // }else{
  //   var index;
  //   for (index = 0; index < 3; index++) {
  //     numList = app.getData().userSetting.servingNumMap[index]
  //     if (numList != undefined && numList instanceof Array && numList.length > 0) {
  //       break
  //     }
  //   }
  // }

  var endDigit = parseInt(num.substring(num.length - 1))
  var callForwardNum = numList[endDigit % numList.length]
  console.log(TAG, 'numList', numList, callForwardNum)
  return callForwardNum
}

// 注意url链接号码需要转义,调用formatTelUrl
function getOpenAiPhoneNum (aiPhoneNum) {
  let mobileServerName = getMobileServer(app.getData().userSetting.phoneNum)
  let {
    mobileServer
  } = app.getData()
  console.log(mobileServerName, mobileServer)
  return mobileServer[mobileServerName].bind.start + aiPhoneNum + mobileServer[mobileServerName].bind.end
}

/**
 * 获取指定模式下关闭的转接命令
 * @param key 代接模式
 */
function getPatternCloseCmd (pattern) {
  let phone = app.getData().userSetting.phoneNum
  let mobileServerName = getMobileServer(phone)
  let {
    mobileServer
  } = app.getData()
  let actNum = mobileServer[mobileServerName][pattern]['close']
  return actNum.start
}

/**
 * 获取指定模式下开启的转接命令
 * @param key 代接模式
 */
function getPatternOpenCmd (pattern, redirectNum) {
  let phone = app.getData().userSetting.phoneNum
  let mobileServerName = getMobileServer(phone)
  let {
    mobileServer
  } = app.getData()
  let actNum = mobileServer[mobileServerName][pattern]['open']
  return actNum.start + redirectNum + actNum.end
}

function formatTelUrl (rawPhone) {
  return 'tel:' + rawPhone.replace(/#/g, encodeURIComponent('#'))
}

function getMobileServer (phone) {
  const isChinaMobile = /^134[0-8]\d{7}$|^(?:13[5-9]|147|15[0-27-9]|178|18[2-478]|198)\d{8}$/ // 移动
  const isChinaUnion = /^(?:13[0-2]|14[56]|15[56]|166|17[56]|18[56])\d{8}$/ // 联通
  const isChinaTelcom = /^(?:133|153|177|199|191|18[019])\d{8}$/ // 1349号段 电信
  const isOtherTelphone = /^170([059])\d{7}$/ // 其他运营商
  if (isChinaMobile.test(phone)) return 'chinaMobile'
  if (isChinaUnion.test(phone)) return 'chinaUnion'
  if (isChinaTelcom.test(phone)) return 'chinaTelcom'
  return 'unkown'
}

function openHelpWeb () {
  var callforwardNum = getCallForwardNum()
  if (app.getData().platform === 'android') {
    jsbridge.openUrl('https://sdi.3g.qq.com/v/2020110410201911702?num=' + callforwardNum)
  } else {
    jsbridge.openUrl('https://sdi.3g.qq.com/v/2020110410201911702?num=' + callforwardNum)
  }
}

function Toast (msg, duration) {
  duration = isNaN(duration) ? 3000 : duration
  var m = document.createElement('div')
  m.innerHTML = msg
  m.style.cssText =
    'width: 72%;' +
    'min-width: 20%;' +
    'padding:0.5rem;' +
    'color:rgb(255, 255, 255);' +
    'line-height: 1.2rem;' +
    'text-align: center;' +
    'border-radius: 0.2rem;' +
    'position: fixed;' +
    'top: 88%;left: 50%;' +
    'transform: translate(-50%, -50%);' +
    'z-index: 999999;' +
    'background: rgba(0, 0, 0,.7);' +
    'font-size: 1rem;' +
    'word-break:break-all;'

  document.body.appendChild(m)
  setTimeout(function () {
    var d = 0.5
    m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in'
    m.style.opacity = '0'
    setTimeout(function () {
      document.body.removeChild(m)
    }, d * 1000)
  }, duration)
}

export default {
  isPhoneNumber,
  retryPromise,
  getUrlKey,
  isEmpty,
  getCallForwardNum,
  getOpenAiPhoneNum,
  formatTelUrl,
  getPatternCloseCmd,
  getPatternOpenCmd,
  openHelpWeb,
  Toast
}



// WEBPACK FOOTER //
// ./src/utils/util.js